import { ratioParts } from './ratioParts';

/**
 * A share with the counts behind it (ADR 0012 Decision 16). Takes a numerator and a denominator and
 * never a ratio: a ratio alone cannot be turned back into the counts, so a component accepting one
 * could not keep the promise that every percentage shows them. Nothing to divide by draws no bar and
 * no percentage — the counts are still true, the share would be invented.
 *
 * The fill is ink rather than the signal colour: in the Rail a signal fill would read as a job to do,
 * and a share is a fact.
 */
export function Ratio({ numerator, denominator }: { numerator: number; denominator: number }) {
  const parts = ratioParts(numerator, denominator);
  return (
    <div className="flex items-center gap-3">
      {parts.fraction === null ? null : (
        <span className="h-2 flex-1 bg-line" aria-hidden>
          <span className="block h-full bg-ink-800" style={{ width: `${Math.min(parts.fraction, 1) * 100}%` }} />
        </span>
      )}
      <span className="num shrink-0 font-mono text-xs text-ink-800">
        {parts.text}
        {parts.percent === null ? null : ` · ${parts.percent}`}
      </span>
    </div>
  );
}
